<template>
  <path
    d="M17 1.00024H7.00001C5.90001 1.00024 5.01001 1.90024 5.01001 3.00024V21.0002C5.01001 22.1002 5.90001 23.0002 7.00001 23.0002H17C18.1 23.0002 19 22.1002 19 21.0002V3.00024C19 1.90024 18.1 1.00024 17 1.00024ZM17 19.0002H7.00001V5.00024H17V19.0002ZM12.8 13.2202V14.9702L15.61 12.3502C15.82 12.1502 15.82 11.8202 15.61 11.6202L12.8 9.00024V10.7002C9.69001 11.1302 8.45001 13.2602 8.00001 15.4002C9.11001 13.9002 10.58 13.2202 12.8 13.2202Z"
  />
</template>
